import * as React from 'react';
import { LocationMonitor } from '@app/components/location-monitor';
export var LoggedPage = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(LocationMonitor, null),
        children));
};
